import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function CopyIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5 6.75C5.5 6.05964 6.05964 5.5 6.75 5.5H13.5C14.0523 5.5 14.5 5.94771 14.5 6.5C14.5 6.91421 14.8358 7.25 15.25 7.25C15.6642 7.25 16 6.91421 16 6.5C16 5.11929 14.8807 4 13.5 4H6.75C5.23122 4 4 5.23122 4 6.75V13.5C4 14.8807 5.11929 16 6.5 16C6.91421 16 7.25 15.6642 7.25 15.25C7.25 14.8358 6.91421 14.5 6.5 14.5C5.94771 14.5 5.5 14.0523 5.5 13.5V6.75ZM9.5 10.75C9.5 10.0596 10.0596 9.5 10.75 9.5H17.25C17.9404 9.5 18.5 10.0596 18.5 10.75V17.25C18.5 17.9404 17.9404 18.5 17.25 18.5H10.75C10.0596 18.5 9.5 17.9404 9.5 17.25V10.75ZM10.75 8C9.23122 8 8 9.23122 8 10.75V17.25C8 18.7688 9.23122 20 10.75 20H17.25C18.7688 20 20 18.7688 20 17.25V10.75C20 9.23122 18.7688 8 17.25 8H10.75Z"
        fill="currentColor"
      />
    </svg>
  );
};
